<div id="cart-status">
  <div class="selected-count">
    موراد انتخاب شده: {{ getSelectedItemsCount() }}
  </div>
  <h3 class="price"><strong>جمع سبد خرید:</strong> {{ getPrice() }}</h3>

  <ng-content select="selector"></ng-content>

  <mat-divider></mat-divider>

  <div *ngIf="transportMethod" class="transportation-price">
    <span *ngIf="transportMethod.valueAdded">
      هزینه ارسال :
      {{ transportMethod.valueAdded | irc : "T" | digitsEnToFa }}
    </span>

    <span
      *ngIf="!transportMethod.valueAdded || +transportMethod.valueAdded === 0"
      >رایگان</span
    >
  </div>
  <mat-divider></mat-divider>

  <p class="price-info">
    هزینه ارسال در ادامه بر اساس آدرس، زمان و نحوه ارسال انتخابی شما متغیر خواهد
    بود.
  </p>
  <div class="actions" fxLayout="column" fxLayoutAlign="center center">
    <payment-payment-submit-btn
      (submit)="submit()"
      [submitTitle]="submitTitle"
      [disabled]="
        status.price === 0 || status.selectedCount === 0 || !!disabled
      "
      [acceptance]="(paymentAcceptance | async)!"
      style="width: 85%"
    ></payment-payment-submit-btn>

    <button
      (click)="openPhoneConfirmDialog()"
      style="border-radius: 10px; text-align: center"
      mat-raised-button
      color="warn"
      *ngIf="!isUserActivated"
    >
      باید قبل از ادامه حساب کاربری خود را فعال کنید
      <jam-icon name="phone"></jam-icon>
    </button>
  </div>
</div>
